(function () {
  "use strict";
  
  if (window.__ReserveTimerFixed) return;

  const DURATION_MS = 10 * 60 * 1000;
  const END_KEY = "reserve_timer_end_fixed_v1";
  const CART_STATE_KEY = "reserve_timer_cart_state";
  const ITEM_COUNT_KEY = "reserve_timer_item_count";
  const FIRST_VISIT_KEY = "reserve_timer_first_visit"; // NEW: Track first visit

  let interval = null;
  let lastRenderedTime = null;
  let cartEmptiedByTimer = false;
  let isEmptyingCart = false;
  let lastCheckedCount = -1;
  let lastCheckedEmpty = null;
  let isInitialLoad = true;
  let elementsFound = false;
  let cachedTimerState = null;

  function getEnd() {
    try {
      const v = localStorage.getItem(END_KEY);
      const n = v ? parseInt(v, 10) : null;
      return n && !isNaN(n) ? n : null;
    } catch (e) {
      return null;
    }
  }

  function setEnd(timestamp) {
    try {
      localStorage.setItem(END_KEY, String(timestamp));
    } catch (e) {}
  }

  function getCartState() {
    try {
      return localStorage.getItem(CART_STATE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setCartState(state) {
    try {
      localStorage.setItem(CART_STATE_KEY, state);
    } catch (e) {}
  }

  function getStoredItemCount() {
    try {
      const v = localStorage.getItem(ITEM_COUNT_KEY);
      return v ? parseInt(v, 10) : 0;
    } catch (e) {
      return 0;
    }
  }

  function setStoredItemCount(count) {
    try {
      localStorage.setItem(ITEM_COUNT_KEY, String(count));
    } catch (e) {}
  }

  // NEW: Check if this is the first visit
  function isFirstVisit() {
    try {
      return !localStorage.getItem(FIRST_VISIT_KEY);
    } catch (e) {
      return true;
    }
  }

  // NEW: Mark that the visitor has been here before
  function markVisited() {
    try {
      localStorage.setItem(FIRST_VISIT_KEY, "true");
    } catch (e) {}
  }

  function format(sec) {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
  }

  function isCartEmpty() {
    const drawer = document.getElementById("cart-drawer");
    return drawer && drawer.classList.contains("drawer-empty");
  }

  function getCartItemCount() {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer) return 0;
    
    const lineItems = drawer.querySelectorAll('.cart-drawer__items > .line-item');
    let count = 0;
    
    lineItems.forEach(function(item) {
      if (!item.classList.contains('gift-item')) {
        count++;
      }
    });
    
    return count;
  }

  function calculateRemainingSeconds() {
    const end = getEnd();
    if (!end) return 0;
    
    const remainingMs = Math.max(end - Date.now(), 0);
    return Math.ceil(remainingMs / 1000);
  }

  function applyTimerState(root, msg, time, tail, state) {
    if (state.isExpired) {
      root.classList.add("is-expired");
      msg.textContent = state.msgText;
      time.textContent = state.timeText;
      tail.textContent = state.tailText;
    } else {
      root.classList.remove("is-expired");
      msg.textContent = state.msgText;
      time.textContent = state.timeText;
      tail.textContent = state.tailText;
    }
  }

  function renderTimer(forceUpdate) {
    const root = document.getElementById("reserve-timer-global");
    const msg = document.getElementById("rt-msg");
    const time = document.getElementById("rt-time");
    const tail = document.getElementById("rt-tail");
    
    if (!root || !msg || !time || !tail) {
      elementsFound = false;
      return;
    }

    elementsFound = true;
    const sec = calculateRemainingSeconds();
    
    if (!forceUpdate && sec === lastRenderedTime) return;
    
    lastRenderedTime = sec;

    const state = {
      isExpired: sec <= 0,
      msgText: sec <= 0 ? "Place your order now" : "Your order is reserved for",
      timeText: sec <= 0 ? "00:00" : format(sec),
      tailText: sec <= 0 ? "" : "minutes"
    };

    cachedTimerState = state;
    applyTimerState(root, msg, time, tail, state);
  }

  function checkAndHandleCartState() {
    if (cartEmptiedByTimer || isEmptyingCart) return;
    
    const isEmpty = isCartEmpty();
    const currentItemCount = getCartItemCount();
    const currentState = getCartState();
    const storedCount = getStoredItemCount();
    const remainingSeconds = calculateRemainingSeconds();
    const timerExpired = remainingSeconds <= 0;
    
    if (isEmpty === lastCheckedEmpty && currentItemCount === lastCheckedCount) {
      return;
    }
    
    const wasEmpty = lastCheckedEmpty;
    const previousCount = lastCheckedCount;
    
    lastCheckedEmpty = isEmpty;
    lastCheckedCount = currentItemCount;
    
    // Cart went from having items to empty
    if (isEmpty && !wasEmpty && currentState === "has-items") {
      setCartState("empty");
      setStoredItemCount(0);
      renderTimer(true);
    }
    // Adding items to cart when timer has expired
    else if (previousCount === 0 && currentItemCount > 0 && timerExpired) {
      const newEnd = Date.now() + DURATION_MS;
      setEnd(newEnd);
      setCartState("has-items");
      setStoredItemCount(currentItemCount);
      lastRenderedTime = null;
      renderTimer(true);
    }
    // Adding items back when timer is still running (cart was empty)
    else if (!isEmpty && wasEmpty && currentItemCount > 0 && !timerExpired) {
      setCartState("has-items");
      setStoredItemCount(currentItemCount);
      renderTimer(true);
    }
    // Adding first items when timer is still running
    else if (previousCount === 0 && currentItemCount > 0 && !timerExpired) {
      setCartState("has-items");
      setStoredItemCount(currentItemCount);
      renderTimer(true);
    }
    // Item count changed (added/removed items but cart not empty)
    else if (!isEmpty && currentItemCount > 0 && currentItemCount !== storedCount) {
      setStoredItemCount(currentItemCount);
      if (currentState !== "has-items") {
        setCartState("has-items");
      }
      renderTimer(true);
    }
  }

  function tick() {
    if (!elementsFound) return;
    
    const sec = calculateRemainingSeconds();
    
    if (sec <= 0) {
      const isEmpty = isCartEmpty();
      const count = getCartItemCount();
      
      if (!isEmpty && count > 0 && !cartEmptiedByTimer && !isEmptyingCart) {
        // Timer expired with items - just show expired state
      }
    }
    
    renderTimer(false);
  }

  function observeCartDrawer() {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer) {
      setTimeout(observeCartDrawer, 100);
      return;
    }

    let debounceTimeout = null;
    function debouncedCheck() {
      if (debounceTimeout) clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(checkAndHandleCartState, 150);
    }

    const drawerObserver = new MutationObserver(function(mutations) {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === "class") {
          debouncedCheck();
          break;
        }
      }
    });

    drawerObserver.observe(drawer, { 
      attributes: true,
      attributeFilter: ["class"]
    });

    const itemsContainer = drawer.querySelector('.cart-drawer__items');
    if (itemsContainer) {
      const itemsObserver = new MutationObserver(function(mutations) {
        let itemsChanged = false;
        
        for (let i = 0; i < mutations.length; i++) {
          const mutation = mutations[i];
          if (mutation.type === 'childList') {
            for (let j = 0; j < mutation.addedNodes.length; j++) {
              if (mutation.addedNodes[j].classList && mutation.addedNodes[j].classList.contains('line-item')) {
                itemsChanged = true;
                break;
              }
            }
            for (let j = 0; j < mutation.removedNodes.length; j++) {
              if (mutation.removedNodes[j].classList && mutation.removedNodes[j].classList.contains('line-item')) {
                itemsChanged = true;
                break;
              }
            }
          }
          if (itemsChanged) break;
        }
        
        if (itemsChanged) debouncedCheck();
      });

      itemsObserver.observe(itemsContainer, {
        childList: true,
        subtree: false
      });
    }
  }

  function observeTimerElement() {
    const bodyObserver = new MutationObserver(function(mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        for (let j = 0; j < mutation.addedNodes.length; j++) {
          const node = mutation.addedNodes[j];
          
          let timerElement = null;
          if (node.id === "reserve-timer-global") {
            timerElement = node;
          } else if (node.querySelector) {
            timerElement = node.querySelector("#reserve-timer-global");
          }
          
          if (timerElement && cachedTimerState) {
            const msg = timerElement.querySelector("#rt-msg");
            const time = timerElement.querySelector("#rt-time");
            const tail = timerElement.querySelector("#rt-tail");
            
            if (msg && time && tail) {
              applyTimerState(timerElement, msg, time, tail, cachedTimerState);
              elementsFound = true;
            }
          }
        }
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function checkOnLoad() {
    const drawer = document.getElementById("cart-drawer");
    if (!drawer) {
      setTimeout(checkOnLoad, 100);
      return;
    }

    setTimeout(function() {
      const isEmpty = isCartEmpty();
      const itemCount = getCartItemCount();
      const existingEnd = getEnd();
      const remainingMs = existingEnd ? Math.max(existingEnd - Date.now(), 0) : 0;
      const timerExpired = remainingMs <= 0;
      const firstVisit = isFirstVisit();
      
      // CHANGED: Only start timer on first visit with items in cart
      if (firstVisit) {
        if (itemCount > 0) {
          // First visit with items - start the timer
          const newEnd = Date.now() + DURATION_MS;
          setEnd(newEnd);
          setCartState("has-items");
          setStoredItemCount(itemCount);
          markVisited();
        } else {
          // First visit with empty cart - don't start timer, just mark visited
          markVisited();
          setCartState("empty");
          setStoredItemCount(0);
          // Set a "never expires" timer so UI shows 00:00
          setEnd(0);
        }
      }
      // Not first visit - use existing timer logic
      else if (!existingEnd || (timerExpired && itemCount > 0)) {
        const newEnd = Date.now() + DURATION_MS;
        setEnd(newEnd);
        setCartState(itemCount > 0 ? "has-items" : "empty");
        setStoredItemCount(itemCount);
      }
      else if (existingEnd && !timerExpired) {
        setCartState(itemCount > 0 ? "has-items" : "empty");
        setStoredItemCount(itemCount);
      }
      else if (timerExpired && itemCount === 0) {
        setCartState("empty");
        setStoredItemCount(0);
      }
      
      lastCheckedEmpty = isEmpty;
      lastCheckedCount = itemCount;
      isInitialLoad = false;
      
      renderTimer(true);
    }, 500);
  }

  function initialize() {
    if (!interval) {
      interval = setInterval(tick, 1000);
    }

    observeCartDrawer();
    observeTimerElement();
    checkOnLoad();
  }

  window.__ReserveTimerFixed = { 
    init: initialize,
    forceUpdate: function() {
      lastRenderedTime = null;
      renderTimer(true);
    },
    reset: function() {
      const newEnd = Date.now() + DURATION_MS;
      setEnd(newEnd);
      lastRenderedTime = null;
      renderTimer(true);
    },
    getRemaining: calculateRemainingSeconds,
    // NEW: Add method to clear first visit flag for testing
    clearFirstVisit: function() {
      try {
        localStorage.removeItem(FIRST_VISIT_KEY);
        console.log("✅ First visit flag cleared");
      } catch (e) {
        console.error("Failed to clear first visit flag");
      }
    },
    debug: function() {
      console.log("🐛 Debug:");
      console.log("  Empty:", isCartEmpty());
      console.log("  Count:", getCartItemCount());
      console.log("  State:", getCartState());
      console.log("  Stored Count:", getStoredItemCount());
      console.log("  Remaining:", calculateRemainingSeconds() + "s");
      console.log("  End timestamp:", new Date(getEnd()).toLocaleTimeString());
      console.log("  First visit:", isFirstVisit());
      console.log("  Cached state:", cachedTimerState);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    setTimeout(initialize, 50);
  }
})();    
           var initGorgiasChatPromise = (window.GorgiasChat)
        ? window.GorgiasChat.init()
        : new Promise(function (resolve) {
            window.addEventListener('gorgias-widget-loaded', function () {
              resolve();
            });
          });

      initGorgiasChatPromise.then(() => {
        const checkIframe = setInterval(() => {
          const iframe = document.querySelector('#chat-window'); // Adjust selector if necessary
          if (iframe) {
            clearInterval(checkIframe); // Stop checking once iframe is found

            iframe.addEventListener('load', () => {
              const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
              if (iframeDocument) {
                const style = iframeDocument.createElement('style');
                style.innerHTML = `
                  .message-window-iframe-1lvuhka .messageLink{
                    color: rgba(0, 0, 0, 1) !important;
                    -webkit-text-fill-color:rgba(0, 0, 0, 1) !important;
                  }
                `;
                iframeDocument.head.appendChild(style);

                // Force Safari to repaint
                const frameBody = iframeDocument.body;
                frameBody.style.display = 'none'; // Hide iframe content temporarily
                setTimeout(() => {
                  frameBody.style.display = ''; // Restore iframe content
                }, 50);

                console.log('Custom Gorgias Chat iframe styles applied.');
              }
            });
          }
        }, 100); // Check every 100ms
      });
     

     
      document.addEventListener("DOMContentLoaded", function () {

    const alreadyClosed = localStorage.getItem("cookiesAccepted") === "true";

    const observeBanner = new MutationObserver(function (mutations, observer) {
        const banner = document.getElementById("shopify-pc__banner");
        if (banner) {
            if (alreadyClosed) {
                banner.style.display = "none";
                observer.disconnect();
                return;
            }

            observer.disconnect();

            const bannerBody = banner.querySelector(".shopify-pc__banner__body");
            const titleElement = bannerBody?.querySelector("#shopify-pc__banner__body-title");

            if (bannerBody && titleElement) {
                const wrapperDiv = document.createElement("div");
                wrapperDiv.className = "cookie-banner-wrapper";
                wrapperDiv.style.display = "flex";
                wrapperDiv.style.alignItems = "baseline";
                wrapperDiv.style.justifyContent = "space-between";

                const closeIcon = document.createElement("span");
                closeIcon.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path fill="#000" d="M7.41401 6.00012L11.707 1.70721C12.098 1.31622 12.098 0.684236 11.707 0.293244C11.316 -0.097748 10.684 -0.097748 10.293 0.293244L6.00001 4.58615L1.70701 0.293244C1.31601 -0.097748 0.684006 -0.097748 0.293006 0.293244C-0.0979941 0.684236 -0.0979941 1.31622 0.293006 1.70721L4.58601 6.00012L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.4141L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00012Z"></path></svg>`;
                closeIcon.style.cursor = "pointer";
                closeIcon.style.color = "#000";
                closeIcon.title = "Close";
                closeIcon.classList.add("cookie-banner-close");
                closeIcon.id = "cookie-banner-close-icon";

                closeIcon.addEventListener("click", function () {
                    // Trigger the actual accept button click so Shopify registers consent
                    const acceptBtn = document.getElementById("shopify-pc__banner__btn-accept");
                    if (acceptBtn) {
                        acceptBtn.click();
                    }

                    // Store accepted state in localStorage
                    localStorage.setItem("cookiesAccepted", "true");

                    // Print all cookies to console
                    const allCookies = document.cookie.split("; ").map(cookie => {
                        const [name, value] = cookie.split("=");
                        return { name: decodeURIComponent(name), value: decodeURIComponent(value) };
                    });

                    allCookies.forEach(cookie => {
                        console.log("Cookies Accepted");
                    });
                    console.groupEnd();
                });

                titleElement.parentNode.insertBefore(wrapperDiv, titleElement);
                wrapperDiv.appendChild(titleElement);
                wrapperDiv.appendChild(closeIcon);
            }
        }
    });

    observeBanner.observe(document.body, { childList: true, subtree: true });
});
 
/**
 * Cart Drawer - Cookie Banner Integration
 * Prevents cart drawer from closing when cookie banner buttons are clicked
 */
(function() {
  'use strict';

  const SELECTORS = {
    cartDrawer: 'cart-drawer',
    cookieBanner: '#shopify-pc__banner',
    cookieCloseIcon: '#cookie-banner-close-icon',
    cookieCloseClass: '.cookie-banner-close',
    cookieAcceptBtn: '.shopify-pc__banner__btn-accept'
  };

  let preventCloseUntil = 0;

  function shouldPreventClose() {
    return Date.now() < preventCloseUntil;
  }

  function setPreventionFlag(durationMs = 300) {
    preventCloseUntil = Date.now() + durationMs;
  }

  function isClickOnCookieBanner(target) {
    if (!target) return false;
    
    // Check close icon
    const closeIcon = document.querySelector(SELECTORS.cookieCloseIcon);
    if (closeIcon && (closeIcon === target || closeIcon.contains(target))) {
      return true;
    }
    
    // Check close class
    const closeElement = target.closest(SELECTORS.cookieCloseClass);
    if (closeElement) return true;
    
    // Check accept button
    const acceptBtn = target.closest(SELECTORS.cookieAcceptBtn);
    if (acceptBtn) return true;
    
    // Check SVG elements
    const tagName = target.tagName ? target.tagName.toLowerCase() : '';
    if (tagName === 'svg' || tagName === 'path') {
      const parent = target.closest(SELECTORS.cookieCloseClass);
      if (parent) return true;
    }
    
    return false;
  }

  function closeCookieBanner() {
    const banner = document.querySelector(SELECTORS.cookieBanner);
    if (banner) {
      banner.style.display = 'none';
      localStorage.setItem("cookiesAccepted", "true");
    }
  }

  function overrideCartDrawerBehavior() {
    const cartDrawerElement = document.querySelector(SELECTORS.cartDrawer);
    
    if (!cartDrawerElement || cartDrawerElement._cookieBannerOverridden) {
      return;
    }

    const originalHideForOutsideClickTarget = cartDrawerElement.hideForOutsideClickTarget.bind(cartDrawerElement);

    cartDrawerElement.hideForOutsideClickTarget = function(target) {
      if (isClickOnCookieBanner(target)) {
        closeCookieBanner();
        return false;
      }

      if (shouldPreventClose()) {
        return false;
      }

      return originalHideForOutsideClickTarget(target);
    };

    cartDrawerElement._cookieBannerOverridden = true;
  }

  function attachCookieBannerListeners() {
    const observer = new MutationObserver(function(mutations, obs) {
      const closeIcon = document.querySelector(SELECTORS.cookieCloseIcon);
      const acceptBtn = document.querySelector(SELECTORS.cookieAcceptBtn);
      
      if (closeIcon && !closeIcon._listenerAttached) {
        closeIcon.addEventListener('mousedown', function() {
          setPreventionFlag(300);
        }, true);
        closeIcon._listenerAttached = true;
      }

      if (acceptBtn && !acceptBtn._listenerAttached) {
        acceptBtn.addEventListener('mousedown', function() {
          setPreventionFlag(300);
        }, true);
        acceptBtn._listenerAttached = true;
      }

      if (closeIcon?._listenerAttached && acceptBtn?._listenerAttached) {
        obs.disconnect();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function attachGlobalClickInterceptor() {
    document.addEventListener('mousedown', function(event) {
      if (isClickOnCookieBanner(event.target)) {
        setPreventionFlag(300);
      }
    }, true);
  }

  function observeCartDrawer() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches && node.matches(SELECTORS.cartDrawer)) {
            overrideCartDrawerBehavior();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    attachGlobalClickInterceptor();
    attachCookieBannerListeners();
    observeCartDrawer();
    overrideCartDrawerBehavior();
  }

  init();

})();
      
document.addEventListener("DOMContentLoaded", function () {
    // Helper function to get the variant ID from the URL
    const getVariantIdFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get("variant"); // Extract the variant parameter
    };

    // Function to toggle section visibility based on variant ID
    const toggleSections = (variantId) => {
        const sections = document.querySelectorAll("#dynamic-product-slider");

        sections.forEach(section => {
            const sectionVariantId = section.dataset.variantId;
            const isDefault = section.dataset.default === "true";

            if (variantId) {
                section.style.display = sectionVariantId === variantId ? "block" : "none";
            } else {
                section.style.display = isDefault ? "block" : "none";
            }
        });
    };

    // Function to initialize the slider
    const initializeSlider = (section) => {
        const sliderContainer = section.querySelector(".slider-container");
        const sliderItems = section.querySelectorAll(".slider-item");
        const leftArrow = section.querySelector(".left-arrow");
        const rightArrow = section.querySelector(".right-arrow");

        if (!sliderContainer || sliderItems.length === 0 || !leftArrow || !rightArrow) {
            console.warn("Required elements missing in this slider.");
            return;
        }

        // Calculate maximum scrollable distance
        const getMaxScrollLeft = () => sliderContainer.scrollWidth - sliderContainer.clientWidth;

        // Update arrow visibility
        const updateArrowVisibility = () => {
            const maxScrollLeft = getMaxScrollLeft();
            leftArrow.style.display = sliderContainer.scrollLeft > 0 ? "block" : "none";
            rightArrow.style.display =
                Math.ceil(sliderContainer.scrollLeft) >= maxScrollLeft ? "none" : "block";
        };

        // Scroll the slider
        const scrollSlider = (direction) => {
            const itemWidth = sliderItems[0].offsetWidth + parseFloat(getComputedStyle(sliderItems[0]).marginRight);
            const maxScrollLeft = getMaxScrollLeft();
            let targetScrollLeft = sliderContainer.scrollLeft;

            if (direction === "left") {
                targetScrollLeft = Math.max(0, targetScrollLeft - itemWidth);
            } else if (direction === "right") {
                targetScrollLeft = Math.min(maxScrollLeft, targetScrollLeft + itemWidth);
            }

            sliderContainer.scrollTo({
                left: targetScrollLeft,
                behavior: "smooth",
            });

            // Update arrow visibility after the scroll ends
            setTimeout(updateArrowVisibility, 300);
        };

        // Attach event listeners
        leftArrow.addEventListener("click", () => scrollSlider("left"));
        rightArrow.addEventListener("click", () => scrollSlider("right"));
        sliderContainer.addEventListener("scroll", updateArrowVisibility);

        // Initial visibility update
        updateArrowVisibility();
    };

    // Reset sliders for visible sections
    const resetSliders = () => {
        const visibleSections = document.querySelectorAll("#dynamic-product-slider[style='display: block;']");

        visibleSections.forEach(section => {
            if (!section.dataset.initialized) {
                initializeSlider(section);
                section.dataset.initialized = "true"; // Mark as initialized
            }
        });
    };

    // Function to observe URL changes for real-time updates
    const observeUrlChanges = () => {
        let lastUrl = window.location.href;

        setInterval(() => {
            const currentUrl = window.location.href;
            if (currentUrl !== lastUrl) {
                lastUrl = currentUrl;
                const variantId = getVariantIdFromUrl();
                toggleSections(variantId);
                resetSliders();
            }
        }, 300); // Check every 300ms for URL changes
    };

    // Initialize
    const initialVariantId = getVariantIdFromUrl();
    toggleSections(initialVariantId);
    resetSliders();
    observeUrlChanges();
});
 
    
     
document.addEventListener('DOMContentLoaded', function () {
    // Helper function to get the variant ID from the URL
    const getVariantIdFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('variant'); // Extract the variant parameter
    };

    // Function to toggle visibility of blocks
    const toggleBlocks = (variantId) => {
        const blocks = document.querySelectorAll('.variant-block');
        let defaultBlockDisplayed = false;

        blocks.forEach(block => {
            const isDefault = block.dataset.default === 'true'; // Check if it's the default block

            if (variantId) {
                // Show matching block if variantId exists
                if (block.dataset.variantId === variantId) {
                    block.style.display = 'block';
                } else {
                    block.style.display = 'none';
                }
            } else if (isDefault && !defaultBlockDisplayed) {
                // Show the default block if no variantId and not already displayed
                block.style.display = 'block';
                defaultBlockDisplayed = true;
            } else {
                // Hide all non-matching and non-default blocks
                block.style.display = 'none';
            }
        });
    };

    // Observe for real-time URL changes
    const observeUrlChanges = () => {
        let lastUrl = window.location.href;

        setInterval(() => {
            const currentUrl = window.location.href;
            if (currentUrl !== lastUrl) {
                lastUrl = currentUrl;
                const variantId = getVariantIdFromUrl();
                toggleBlocks(variantId); // Update blocks dynamically
            }
        }, 100); // Check every 100ms for URL changes
    };

    // Get initial variant ID and toggle blocks
    const initialVariantId = getVariantIdFromUrl();
    toggleBlocks(initialVariantId);

    // Start observing URL changes
    observeUrlChanges();
});
 
 
document.addEventListener("DOMContentLoaded", function () {
    let updateTimeout;
    let isUpdating = false; // Flag to prevent infinite loops
    
    function updateWarrantyLabel() {
    
    // Prevent multiple simultaneous updates
    if (isUpdating) {
        return;
    }
    
    // Clear any pending updates
    if (updateTimeout) {
        clearTimeout(updateTimeout);
    }
    
    updateTimeout = setTimeout(function() {
        isUpdating = true;
        
        // Select the warranty label container
        let warrantyContainer = document.querySelector('.product-with-gallery .product-gallery .warranty-label-container');
        let warrantyLabel = document.querySelector('.product-with-gallery .product-gallery .warranty-label');

        if (!warrantyContainer || !warrantyLabel) {
            isUpdating = false;
            return;
        }

        // Find ALL media elements first
        let allMediaElements = document.querySelectorAll('.product-with-gallery .product-gallery .product-gallery__media');
        
        // Check product handle
        let productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0]; 
        let targetIndex =   (productHandle === 'nobl-duo-bundle' || productHandle === 'the-nobl-travel-bundle-no-carry-on' || productHandle === 'the-nobl-travel-bundle-no-check-in' || productHandle === 'the-nobl-travel-bundle-no-weekender-bag' || productHandle === 'the-nobl-travel-bundle-no-carry-on-check-in' || productHandle === 'the-nobl-travel-bundle-no-nobl-duo' || productHandle === 'the-nobl-travel-bundle-no-carry-on-cubes' || productHandle === 'the-nobl-travel-bundle-no-carry-on-and-bottle' || productHandle === 'the-nobl-travel-bundle-no-carry-no-tag' || productHandle === 'nobl-travel-bundle-no-check-in-no-bag' || productHandle === 'the-nobl-travel-bundle-no-check-in-no-cubes' || productHandle === 'the-nobl-travel-bundle-no-check-in-no-bottle' || productHandle === 'the-nobl-travel-bundle-no-check-no-tag' || productHandle === 'the-nobl-travel-bundle-no-bag-no-cubes' || productHandle === 'the-nobl-travel-bundle-no-bag-no-bottle' || productHandle === 'the-nobl-travel-bundle-no-bag-no-tag' || productHandle === 'the-nobl-travel-bundle-no-cubes-no-bottle' || productHandle === 'the-nobl-travel-bundle-no-cube-no-tag' || productHandle === 'the-nobl-travel-bundle-no-bttle-no-tag' || productHandle === 'the-nobl-travel-bundle-no-carry-no-check-no-bag' || productHandle === 'the-nobl-travel-bundle-no-carry-no-check-no-cubes' || productHandle === 'the-nobl-travel-bundle-no-carry-no-check-no-bottle' )   ? 1   : 0;
        
        // Find visible media elements
        let visibleMediaElements = [];
        allMediaElements.forEach(function(media) {
            let isHidden = media.hasAttribute('hidden') || media.style.display === 'none' || media.querySelector('img[alt="card-only"]');
            
            if (!isHidden) {
                visibleMediaElements.push(media);
            }
        });

        // Get the target media (1st for normal products, 3rd for nobl-duo-bundle)
        let targetMedia = visibleMediaElements[targetIndex];

        if (targetMedia) {
            let targetImage = targetMedia.querySelector('img');
            
            if (targetImage) {
                // Check if warranty container is already in the correct position
                if (targetMedia.contains(warrantyContainer)) {
                    isUpdating = false;
                    return; // Already in correct position, no need to move
                }
                
                // Ensure the parent container has relative positioning
                targetMedia.style.position = "relative";

                // Move the warranty label container to the target media
                targetMedia.appendChild(warrantyContainer);

                // Apply positioning styles
                warrantyContainer.style.left = "20px";
               
            } 
        }
        
        isUpdating = false;
    }, 100); // Short delay to ensure DOM is updated
}

    // Initial run
    updateWarrantyLabel();

    // Function to set up all event listeners
    function setupEventListeners() {
        // Listen for changes on variant selectors with longer delays
        document.querySelectorAll('.product-info input[type="radio"][name="option1"]').forEach(function(radio) {
            radio.addEventListener('change', function() {
                setTimeout(updateWarrantyLabel, 800); // Longer delay
            });
        });

        // Listen for clicks on color swatch labels
        document.querySelectorAll('.product-info label.color-swatch').forEach(function(label) {
            label.addEventListener('click', function() {
                setTimeout(updateWarrantyLabel, 800); // Longer delay
            });
        });

        // Listen for variant picker changes
        const variantPicker = document.querySelector('.product-info variant-picker');
        if (variantPicker) {
            variantPicker.addEventListener('change', function() {
                setTimeout(updateWarrantyLabel, 800);
            });
        }
    }

    // Set up event listeners
    setupEventListeners();

    // Use MutationObserver to watch for changes in media visibility - BUT BE MORE SPECIFIC
    const observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        
        mutations.forEach(function(mutation) {
            // Only respond to 'hidden' attribute changes on media elements
            // Ignore other changes like class additions/removals
            if (mutation.type === 'attributes' && 
                mutation.attributeName === 'hidden' && 
                mutation.target.classList.contains('product-gallery__media')) {
                shouldUpdate = true;
            }
            
            // Also respond to new media elements being added/removed (variant changes)
            if (mutation.type === 'childList' && 
                mutation.target.classList.contains('product-gallery__carousel')) {
                const addedNodes = Array.from(mutation.addedNodes);
                const removedNodes = Array.from(mutation.removedNodes);
                
                // Only update if media elements were actually added/removed
                if (addedNodes.some(node => node.classList && node.classList.contains('product-gallery__media')) ||
                    removedNodes.some(node => node.classList && node.classList.contains('product-gallery__media'))) {
                    shouldUpdate = true;
                }
            }
        });
        
        if (shouldUpdate && !isUpdating) {
            setTimeout(updateWarrantyLabel, 300);
        }
    });

    // Start observing the product gallery - but be more specific about what we watch
    const productGallery = document.querySelector('.product-with-gallery .product-gallery .product-gallery__carousel');
    if (productGallery) {
        observer.observe(productGallery, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['hidden'] // Only watch for hidden attribute changes
        });
    }

    // Reduced frequency fallback check
setInterval(function() {
    const warrantyContainer = document.querySelector('.product-with-gallery .product-gallery .warranty-label-container');
    
    // Check product handle
    let productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    let selector = (productHandle === 'nobl-duo-bundle') 
        ? '.product-with-gallery .product-gallery .product-gallery__media:not([hidden]):nth-of-type(2)' 
        : '.product-with-gallery .product-gallery .product-gallery__media:not([hidden])';
    
    const targetMedia = document.querySelector(selector);
    
    if (warrantyContainer && targetMedia && 
        !targetMedia.contains(warrantyContainer) && !isUpdating) {
        updateWarrantyLabel();
    }
}, 5000);

    // Also try to update after page is fully loaded
    window.addEventListener('load', function() {
        setTimeout(updateWarrantyLabel, 1000);
    });
});

  
     
      // Add this to your theme.js file or create a new JS file and include it in your theme

document.addEventListener('DOMContentLoaded', function() {
  // Function to handle form submission for add to cart buttons
  function handleAddToCartSubmit() {
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    
    addToCartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const addToCartButton = form.querySelector('#add-to-cart-button');
        
        // Only apply temp disabled to add-to-cart buttons, not sold-out buttons
        if (addToCartButton) {
          // We can still add the visual disabled class for feedback
          addToCartButton.classList.add('button--disabled');
          
          // But we won't add the actual disabled attribute
          // This prevents the issue with the attribute persisting
          
          // Reset the button after a short delay (for visual feedback)
          setTimeout(() => {
            addToCartButton.classList.remove('button--disabled');
          }, 1000);
        }
      });
    });
  }
  
  // Initialize the handlers
  handleAddToCartSubmit();
  
  // Re-initialize handlers after Shopify section updates
  document.addEventListener('shopify:section:load', handleAddToCartSubmit);
});
     
     
function removeZeroDecimals() {
    document.querySelectorAll('.loox-rating-label').forEach(function(el) {
        el.innerHTML = el.innerHTML.replace('.0', '');
    });
}

// Try multiple times to catch when Loox loads
setTimeout(removeZeroDecimals, 1000);

// Also try when page is fully loaded
window.addEventListener('load', function() {
    setTimeout(removeZeroDecimals, 1000);
});
 



// Fixed Product cards Variants Handler for changing variant id
document.addEventListener('change', function(event) {
  if (event.target.type === 'radio' && event.target.closest('[data-option-position]')) {
    updateVariant(event.target);
  }
});

document.addEventListener('click', function(event) {
  if (event.target.closest('[data-option-value]')) {
    setTimeout(() => updateVariant(event.target), 10);
  }
});

function updateVariant(element) {
  const productCard = element.closest('.product-list [data-product-id]');
  if (!productCard) return;
  
  const productId = productCard.getAttribute('data-product-id');
  const variantScript = document.querySelector(`[data-product-variants="${productId}"]`);
  
  if (!variantScript) return;
  
  const data = JSON.parse(variantScript.textContent);
  const selectedOptions = [];
  
  // Get selected options
  data.options.forEach((option, index) => {
    const selected = productCard.querySelector(`[data-option-position="${index + 1}"] input:checked`);
    selectedOptions[index] = selected ? selected.value : data.variants[0].options[index];
  });
  
  // Find matching variant
  const variant = data.variants.find(v => 
    selectedOptions.every((opt, i) => v.options[i] === opt)
  );
  
  if (variant) {
    
    // Update data-variant-id attributes
    productCard.querySelectorAll('[data-variant-id]').forEach(el => {
      el.setAttribute('data-variant-id', variant.id);
    });
    
    // Update variant ID class on media element
    const mediaEl = productCard.querySelector('.product-card__media');
    if (mediaEl) {
      
      // Remove all existing variant ID classes (numbers only)
      let classList = mediaEl.className.split(' ');
      classList = classList.filter(cls => !cls.match(/^\d+$/));
      
      // Add new variant ID class
      classList.push(variant.id.toString());
      
      // Update the className
      mediaEl.className = classList.join(' ');
      
    }
    
    // Update product card ID
    productCard.id = `product-${variant.id}`;
    
    // Update quick buy form
    const hiddenInput = productCard.querySelector('input[name="id"]');
    if (hiddenInput) hiddenInput.value = variant.id;
    
  }
}

// document.addEventListener("variant:change", function (event) {
//   const variant = event.detail.variant;
//   if (!variant) return;

//   const variantId = String(variant.id);

//   document.querySelectorAll("[data-sl-attribute-p]").forEach(el => {
//     el.setAttribute("data-sl-attribute-p", variantId);
//   });

//   document.querySelectorAll("[data-sl-attribute-cap]").forEach(el => {
//     el.setAttribute("data-sl-attribute-cap", variantId);
//   });

//   document.querySelectorAll("[data-sl-attribute-discount]").forEach(el => {
//     el.setAttribute("data-sl-attribute-discount", variantId);
//   });

//   document.querySelectorAll("[data-sl-pid]").forEach(el => {
//     el.setAttribute("data-sl-pid", variantId);
//   });
// });